import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoCorrect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAutoCorrect"><Path d="M3 20L10.591 3L15.81 14.6875H5.71112" stroke="currentColor" strokeLinecap="square"/><Path d="M14 19.3333L16.6667 22L22 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAutoCorrect;
